import { GetThunkAPI } from '@reduxjs/toolkit/dist/createAsyncThunk';
import RequestService from '@tcc-online/request-service';
import { NotificationActions } from '../../common/actions/NotificationActions';
import ProjectAdminType from '../types/ProjectAdminType';

const AdminProjectAdminsService = {
    getAdmins,
    createAdmin,
    updateAdmin,
};

const createUrl = (params: {
    productType: number;
    projectId: number;
    adminId?: number;
    limit?: number;
}) => {
    const { productType, projectId, adminId, limit } = params;
    let url = `/admin/products/${productType}/projects/${projectId}/admins`;
    if (adminId !== null && adminId !== undefined) {
        url += `/${adminId}`;
    }

    if (limit) {
        url += `?limit=${limit}`;
    }

    return url;
};

interface BasePayload {
    productType: number;
    projectId: number;
}

async function getAdmins(
    payload: BasePayload & { limit?: number },
    thunkApi: GetThunkAPI<any>,
) {
    const { productType, projectId, limit } = payload;
    try {
        return await RequestService.get<ProjectAdminType[]>(
            createUrl({ productType, projectId, limit }),
        );
    } catch (e) {
        thunkApi?.dispatch(
            NotificationActions.error('nepodarilo se nacist adminy'),
        ); // TODO: translate

        throw e;
    }
}

interface CreatePayload {
    userId: number;
    type: number;
    notificationSetting: number;
}

async function createAdmin(
    payload: CreatePayload & BasePayload,
    thunkApi: GetThunkAPI<any>,
) {
    const { productType, projectId, userId, type, notificationSetting } =
        payload;
    try {
        return await RequestService.post<CreatePayload, ProjectAdminType>(
            createUrl({ productType, projectId }),
            { userId, type, notificationSetting },
        );
    } catch (e) {
        thunkApi?.dispatch(
            NotificationActions.error('nepodarilo se nacist adminy'),
        ); // TODO: translate

        throw e;
    }
}

interface UpdatePayload {
    type?: number;
    notificationSetting?: number;
}

async function updateAdmin(
    payload: UpdatePayload & BasePayload & { adminId: number },
    thunkApi: GetThunkAPI<any>,
) {
    const { productType, projectId, adminId, type, notificationSetting } =
        payload;
    try {
        return await RequestService.patch<UpdatePayload, ProjectAdminType>(
            createUrl({ productType, projectId, adminId }),
            { type, notificationSetting },
        );
    } catch (e) {
        thunkApi?.dispatch(
            NotificationActions.error('nepodarilo se nacist adminy'),
        ); // TODO: translate

        throw e;
    }
}

export default AdminProjectAdminsService;
